import { Col, Row } from 'react-bootstrap';
import DashboardNotifications from 'components/global/DashboardNotifications';
import { $list, $user, $view } from 'signals/global.signals';
import PageTitle from 'components/global/PageTitle/PageTitle';
import Loadable from 'components/global/Loadable';
import useEffectAsync from 'utils/useEffectAsync';
import { fetchAndSetInvestorNotifications } from 'components/views/InvestorDashboard/_helpers/investorDashboard.resolvers';
import { handleClickDismissInvestorNotification } from 'components/views/InvestorDashboard/_helpers/investorDashboard.events';
import withDismount from 'hocs/withDismount';

const InvestorDashboard = () => {
  useEffectAsync(fetchAndSetInvestorNotifications);
  return (
    <Loadable signal={$view}>
      <PageTitle>
        Welcome, {$user.value.firstName}
      </PageTitle>
      <Row>
        <Col xs={12} lg={8}>
          <DashboardNotifications data={$list.value?.data || []} onDismiss={handleClickDismissInvestorNotification} />
        </Col>
      </Row>
    </Loadable>
  );
};

export default withDismount(InvestorDashboard);
